import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import TableChartIcon from '@mui/icons-material/TableChart';
import CodeIcon from '@mui/icons-material/Code';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DataObjectIcon from '@mui/icons-material/DataObject';
import SlideshowIcon from '@mui/icons-material/Slideshow';

interface FileIconProps {
    mimeType: string;
    className?: string;
    size?: number;
}

export const FileIcon: React.FC<FileIconProps> = ({
                                                      mimeType = '',
                                                      className = "",
                                                      size = 20
                                                  }) => {
    const getFileIcon = (mimeType: string) => {
        const type = mimeType.toLowerCase();
        const extension = type.split('.').pop()?.toLowerCase() || '';

        // Microsoft Office documents
        if (type.includes('word') || ['doc', 'docx', 'rtf', 'odt'].includes(extension)) {
            return DescriptionIcon;
        }
        if (type.includes('spreadsheet') || ['xls', 'xlsx', 'csv', 'ods'].includes(extension)) {
            return TableChartIcon;
        }
        if (type.includes('presentation') || ['ppt', 'pptx', 'odp'].includes(extension)) {
            return SlideshowIcon;
        }

        // PDF files
        if (type.includes('pdf') || extension === 'pdf') {
            return PictureAsPdfIcon;
        }

        // Media files
        if (type.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(extension)) {
            return ImageIcon;
        }
        if (type.includes('video') || ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'].includes(extension)) {
            return VideoFileIcon;
        }
        if (type.includes('audio') || ['mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac'].includes(extension)) {
            return AudioFileIcon;
        }

        // Code and data files
        if (type.includes('json') || extension === 'json') {
            return DataObjectIcon;
        }
        if (['js', 'ts', 'jsx', 'tsx', 'py', 'java', 'c', 'cpp', 'cs', 'php', 'rb', 'go', 'rs', 'swift'].includes(extension)) {
            return CodeIcon;
        }
        if (['html', 'htm', 'xml', 'md', 'markdown', 'yaml', 'yml'].includes(extension)) {
            return CodeIcon;
        }

        // Archive files
        if (['zip', 'rar', '7z', 'tar', 'gz', 'bz2'].includes(extension)) {
            return FolderZipIcon;
        }

        // Text files
        if (['txt', 'log', 'cfg', 'ini'].includes(extension)) {
            return TextSnippetIcon;
        }

        // Default file icon
        return InsertDriveFileIcon;
    };

    const IconComponent = getFileIcon(mimeType);

    return (
        <IconComponent
            sx={{
                width: size,
                height: size,
                color: 'action.active',
                ...(className?.includes('text-primary') && {
                    color: 'primary.main',
                }),
            }}
            className={className}
        />
    );
};

export default FileIcon;